module.exports = __webpack_public_path__ + "img/home.65267dd9.svg";